import BaseService from './_base.service';

export const suscriptionService = {
    page,
    combo,
    search,
    edit,
    create,
    one,
    remove,
    suscription,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/suscription/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/suscription/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/suscription/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/suscription/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/suscription/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/suscription/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/suscription/"+id, callback);
}

function suscription(page,size, callback) {
    return BaseService.get("/user/suscription/page/"+page+"/"+size, callback, true)
}

function removeLogic(id,callback) {
    return BaseService.delete("/user/suscription/"+id+"/logic", callback);
}
